import { ButtonInstance, ButtonParams, Plugin } from '@jeppesen-foreflight/jmkw-types';
import { BasicButtonComponent } from '@jeppesen-foreflight/jmkw-toolkit';
import { NavigationLayer } from './layer/navigation.layer';

export const IFR_TOGGLE_BUTTON: ButtonParams = {
  id: 'navigation',
  iconName: 'icon-low_ifr',
  buttonComponent: BasicButtonComponent,
  automationKey: 'ifr-toggle-button',
  tooltipText: 'IFR Low/High Toggle',
  submit: (button: ButtonInstance) => {
    const layer =
      button.toolkitApiService.getLayerById<NavigationLayer>('navigation');
    layer?.jepTools.toggleIFR();
    button.iconName = layer?.ifr === 'High' ? 'icon-high_ifr' : 'icon-low_ifr';
  }
};

export const IFR_TOGGLE_PLUGIN = new Plugin({
  id: 'ifr-toggle',
  button: IFR_TOGGLE_BUTTON
});
